import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import NotificationIcon from "../../assets/svg/NotificationIcon";
import NotificationModal from "../modals/NotificationModal";
import { useState } from "react";
import { useEffect } from "react";
import getNotificationList from "../../api/notification/getNotificationList";
import MyText from "../custom/MyText";
import { orange, white } from "../../colors";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationModal } from "../../redux/modal/modalAction";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import translate from "../../functions/translate";

export default function Notification() {
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    getNotificationList().then(({ data }) => {
      if (data.status === 200) {
        setNotifications(data.data);
      }
    });
    const notificationInterval = setInterval(
      () =>
        getNotificationList()
          .then(({ data }) => {
            if (data.status === 200) {
              setNotifications(data.data);
            }
          })
          .catch((err) => {}),
      15000
    );
    return () => clearInterval(notificationInterval);
  }, []);
  return (
    <View>
      <NotificationModal notifications={notifications} />
      {notifications.length > 0 && (
        <View
          style={{
            borderRadius: 15,
            backgroundColor: orange,
            alignItems: "center",
            width: 22,
            height: 22,
            marginBottom: -18,
            marginLeft: -10,
            overflow: "hidden",
          }}
        >
          <MyText
            style={{ color: white, fontSize: 13 }}
          >{`${notifications.length}`}</MyText>
        </View>
      )}
      <TouchableOpacity
        onPress={() =>
          main.token !== null
            ? dispatch(setNotificationModal())
            : Toast.show({
                type: "error",
                text1: translate("please login first"),
              })
        }
        style={{ transform: [{ scale: 0.8 }] }}
      >
        <NotificationIcon />
      </TouchableOpacity>
    </View>
  );
}
